import ModalContentWrapper from "root/Modals/ModalContentWrapper";

const ModalRegistrationResponse = ({onClose, class_name, session, showEmptyResponse}) =>
{

    const session_str = session === 'AM' ? 'morning' : 'afternoon';

    //Show empty response no longer used. It used to show a different message if nothing had changed upon submission but this was deemed too confusing.
    return (
        <ModalContentWrapper className="modal-wrapper" >
            <div style={{background: "#dff0d8", color: "green",  margin: "5px", padding: "10px"}}>
                <h2 style = {{textAlign: "center"}}>Success!</h2>
                <p style = {{textAlign: "center"}}>{class_name} {session_str} register has been submitted.</p>
            </div>
        </ModalContentWrapper>
    )
}

export default ModalRegistrationResponse;